import * as React from 'react'
import { NavLink } from 'react-router-dom'

const Logo = () => {
    return <NavLink to="/">SPYvsGME</NavLink>
}

export { Logo }
